module.exports = __webpack_public_path__ + "static/media/ff-imposters.8cc4ebd0.png";